import React from 'react';

import CardView from 'apps/auth/components/common/Card/CardView';
import NewCardField from 'apps/auth/components/form/NewCardField';
import { CARD_EXP_DATE, PAN } from 'apps/auth/constants/fieldsName';
import { ADD_SOURCE_BANK_CARD } from 'apps/auth/constants/formName';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const CardScreen = (props) => {
    const { cardsCardExpiredDate } = usePageMessages();
    const { binInfo = {}, cardPan } = useExtra();
    const { fields = {} } = useForm(props.formName);
    const clearPanValue = fields[PAN]?.value?.replace(/\s/g, '') ?? '';
    const dataForCardView = {
        cardLogo: binInfo?.bankAlias,
        alias: binInfo?.bankName,
        pan: fields[PAN]?.value && `${clearPanValue.slice(0, 6)}••••••${clearPanValue.slice(12)}`,
        cardExpired: fields[CARD_EXP_DATE]?.value ?? '',
        paymentSystem: binInfo?.paysysName,
    };
    return cardPan ? (
        <CardView defaultLogo="bank" card={dataForCardView} cardExpDateMessage={cardsCardExpiredDate} />
    ) : (
        <NewCardField binExtraName="binInfo" formName={ADD_SOURCE_BANK_CARD} panName={PAN} redirectByBinUrl={false} expiredDateName={CARD_EXP_DATE} />
    );
};
export default CardScreen;
